/**
 * BOGO US Configurator
 * Wheel Type cards switch between products.
 * The actual product page (gallery + form) is fetched via section rendering API
 * and split: gallery → left column, form/options → right column.
 */

(function() {
  'use strict';

  var lastLoadedHandle = '';

  // ===== FILTER WHEEL TYPES BY BIKE =====
  // Called by bogo-us-builder.js when entering the customize step
  // bikeKey: which bike was selected (e.g. 'fs-pro-3')
  // defaultWheelKey: which wheel type to auto-select (e.g. 'fat' or 'mtb')
  window.bogoConfigFilterForBike = function(bikeKey, defaultWheelKey) {
    var cards = document.querySelectorAll('.bogo-cfg-wheel-card');
    var visibleCards = [];

    // Reset all selections
    lastLoadedHandle = '';
    cards.forEach(function(card) {
      card.classList.remove('selected');
      var forBike = (card.dataset.forBike || '').trim().toLowerCase();
      var key = (bikeKey || '').trim().toLowerCase();

      if (!forBike || forBike === key) {
        card.style.display = '';
        visibleCards.push(card);
      } else {
        card.style.display = 'none';
      }
    });

    // Auto-select the default wheel type if specified
    var defaultKey = (defaultWheelKey || '').trim().toLowerCase();
    var autoSelected = false;

    if (defaultKey && visibleCards.length > 0) {
      for (var i = 0; i < visibleCards.length; i++) {
        var wheelKey = (visibleCards[i].dataset.wheelKey || '').trim().toLowerCase();
        if (wheelKey === defaultKey) {
          bogoConfigSelectWheel(visibleCards[i]);
          autoSelected = true;
          break;
        }
      }
    }

    // If no default match, and only one visible, auto-select that one
    if (!autoSelected && visibleCards.length === 1) {
      bogoConfigSelectWheel(visibleCards[0]);
    }
  };

  // ===== WHEEL TYPE SELECTION =====
  window.bogoConfigSelectWheel = function(card) {
    var handle = card.dataset.productHandle;
    var productUrl = card.dataset.productUrl;
    if (!handle) return;

    // Visual feedback
    document.querySelectorAll('.bogo-cfg-wheel-card').forEach(function(c) {
      c.classList.remove('selected');
    });
    card.classList.add('selected');

    // Don't reload same product
    if (handle === lastLoadedHandle) return;
    lastLoadedHandle = handle;

    // Unlock the options section
    var optionsSection = document.getElementById('cfg-product-options');
    if (optionsSection) {
      optionsSection.classList.remove('bogo-cfg-locked');
      optionsSection.classList.add('bogo-cfg-unlocked');
    }

    loadProductPage(productUrl || '/products/' + handle, handle);
  };

  // ===== LOAD PRODUCT PAGE =====
  function loadProductPage(url, handle) {
    var productArea = document.getElementById('cfg-product-area');
    var optionsEmbed = document.getElementById('cfg-options-embed');
    var placeholder = document.getElementById('cfg-product-placeholder');

    if (optionsEmbed) optionsEmbed.innerHTML = '<p style="text-align:center;padding:20px;color:#888;">Loading options...</p>';

    // Fetch the product page section directly (much faster than full page)
    var sectionUrl = url + (url.indexOf('?') > -1 ? '&' : '?') + 'sections=main-product';

    fetch(sectionUrl)
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var html = data['main-product'] || '';
        if (!html) {
          // Fallback: fetch the full page
          return fetch(url).then(function(r) { return r.text(); });
        }
        return html;
      })
      .then(function(html) {
        if (!html || typeof html !== 'string') return;
        var parser = new DOMParser();
        var doc = parser.parseFromString(typeof html === 'string' ? html : '', 'text/html');

        // This theme uses:
        //   .product-block-list__wrapper → the 2-column grid
        //     first child → product gallery block (_product-gallery)
        //     .product-block-list__item.product-information → form/options
        var wrapper = doc.querySelector('.product-block-list__wrapper');

        if (!wrapper) {
          // Fallback: try generic selectors
          wrapper = doc.querySelector('[class*="main-product"]') ||
                    doc.querySelector('.product') ||
                    doc.querySelector('main');
        }

        if (!wrapper) {
          if (optionsEmbed) optionsEmbed.innerHTML = '<p style="color:#888;">Could not load product. <a href="' + url + '" target="_blank" style="color:#4361EE;">Open product page →</a></p>';
          return;
        }

        // Split: gallery is the first child of the wrapper (before .product-information)
        var gallery = wrapper.querySelector('[id*="product-gallery"], [class*="_product-gallery"]');
        if (!gallery) {
          // The gallery is the first .product-block-list__item that isn't .product-information
          var items = wrapper.querySelectorAll('.product-block-list__item');
          if (items.length > 0 && !items[0].classList.contains('product-information')) {
            gallery = items[0];
          }
        }
        if (!gallery) {
          // Last resort: grab the first child of the wrapper
          gallery = wrapper.children[0];
        }

        var info = wrapper.querySelector('.product-information, .product__info, [class*="product-info"]');

        // Put gallery in the left column
        if (gallery && productArea) {
          // Strip non-gallery elements (spec icons, navbar, etc.)
          gallery.querySelectorAll(
            '[class*="product-overview"], [class*="spec-icon"], [class*="product-navbar"], ' +
            '.product-information, .product-form__container, [class*="product-specs"]'
          ).forEach(function(el) { el.remove(); });

          productArea.innerHTML = '';
          productArea.appendChild(gallery);
          if (placeholder) placeholder.classList.add('hidden');
        }

        // Put form/options in the right column
        if (info && optionsEmbed) {
          // Remove elements we don't want in the builder
          var removeSelectors = [
            '.shopify-payment-button',
            '.share-buttons',
            '.product-single__description',
            '.complementary-products',
            '.product-recommendations',
            'combined-listing',
            '[class*="combined-listing"]',
            '[class*="combined_listing"]',
            '[data-combined-listing]',
            'product-siblings',
            '[class*="product-sibling"]',
            '[class*="product_sibling"]'
          ];
          info.querySelectorAll(removeSelectors.join(', ')).forEach(function(el) { el.remove(); });

          // Also remove any option block that only has links to other products
          // (catches the "Ride Style" linked products UI regardless of class name)
          info.querySelectorAll('a[href*="/products/"]').forEach(function(link) {
            // Only remove if the parent block ONLY contains product links (not regular options)
            var parent = link.closest('[class*="block-swatch"]');
            if (parent) {
              // Check if this whole option group is just product links
              var optionGroup = parent.closest('[class*="block-swatch-list"]');
              if (optionGroup) {
                var allLinks = optionGroup.querySelectorAll('a[href*="/products/"]');
                var allInputs = optionGroup.querySelectorAll('input[type="radio"]');
                // If there are product links but no radio inputs, it's a linked product selector
                if (allLinks.length > 0 && allInputs.length === 0) {
                  var wrapper = optionGroup.closest('.product-form__option, [class*="option-wrapper"], fieldset');
                  if (wrapper) wrapper.remove();
                  else optionGroup.remove();
                }
              }
            }
          });

          // Remove description / "Read More" paragraph
          info.querySelectorAll('[class*="paragraph"], [class*="description"], [class*="read-more"]').forEach(function(el) {
            // Only remove if it looks like a product description block (has Read More or long text)
            if (el.querySelector('a[href*="read"]') || el.textContent.length > 100) {
              el.remove();
            }
          });

          // Remove option groups with only 1 value (e.g. "Model Option: MTB")
          // These are useless single-choice options — the wheel type cards handle this
          // IMPORTANT: Skip advanced option upgrade containers — they use <select>, not .block-swatch
          info.querySelectorAll('.block-swatch-list').forEach(function(swatchList) {
            // Skip lists that contain select dropdowns (advanced option upgrades)
            if (swatchList.querySelector('select')) return;
            // Skip lists that are part of the additional-options system
            if (swatchList.classList.contains('additional-options') ||
                swatchList.classList.contains('additional-options__no-SKU')) return;

            var swatches = swatchList.querySelectorAll('.block-swatch');
            if (swatches.length <= 1) {
              var optionContainer = swatchList.closest('.product-form__option, [class*="option"]');
              if (optionContainer) optionContainer.remove();
              else swatchList.remove();
            }
          });

          optionsEmbed.innerHTML = '';
          optionsEmbed.appendChild(info);

          // Fix Advanced Options: the theme's tab system doesn't work on injected HTML.
          // Make the No/Yes toggle functional and auto-expand if "Yes" is selected.
          initAdvancedOptionsTabs(optionsEmbed);
        } else if (optionsEmbed) {
          // Fallback: put the whole wrapper in the options area
          optionsEmbed.innerHTML = '';
          optionsEmbed.appendChild(wrapper);
          initAdvancedOptionsTabs(optionsEmbed);
        }

        // Intercept links inside both areas to prevent navigation
        interceptLinks(productArea);
        interceptLinks(optionsEmbed);

        // Intercept Add to Cart buttons — make them advance to free bike step
        interceptAddToCart(optionsEmbed);
        interceptAddToCart(productArea);

        // Watch for variant changes to sync back to builder
        observeVariantChanges(optionsEmbed, handle);

        // Sync initial state
        syncToBuilder(optionsEmbed, handle);
      })
      .catch(function(err) {
        console.error('[Configurator] Failed to load product page:', err);
        if (optionsEmbed) {
          optionsEmbed.innerHTML = '<p style="color:#888;">Failed to load. <a href="' + url + '" target="_blank" style="color:#4361EE;">Open product page →</a></p>';
        }
      });
  }

  // ===== INTERCEPT ADD TO CART =====
  function interceptAddToCart(container) {
    if (!container) return;

    // Restyle all Add to Cart / submit buttons as "Next Step →"
    function restyleButtons() {
      container.querySelectorAll('[data-action="add-to-cart"], [name="add"], button[type="submit"], .product-form__submit, .btn-blue, .product-form__add-button').forEach(function(btn) {
        if (btn.textContent.trim() !== 'Next Step →') {
          btn.textContent = 'Next Step →';
        }
        btn.style.cssText = 'background: linear-gradient(135deg, #059669, #10B981) !important; color: white !important; border: none !important; cursor: pointer !important;';
      });

      // Hide "Speak To An Expert" / callback buttons
      container.querySelectorAll('[name="scout_callback_button"], .scout-callback-btn, [class*="callback"], [class*="speak-to"], button[class*="yellow"], button[style*="background: rgb(247"]').forEach(function(btn) {
        btn.style.display = 'none';
      });
    }

    // Run immediately
    restyleButtons();

    // Re-run after short delay (theme JS may re-render buttons)
    setTimeout(restyleButtons, 200);
    setTimeout(restyleButtons, 500);
    setTimeout(restyleButtons, 1000);

    // Watch for DOM changes that might re-render the button
    var observer = new MutationObserver(function() {
      restyleButtons();
    });
    observer.observe(container, { childList: true, subtree: true, characterData: true });

    // Hide "Speak To An Expert" / callback buttons
    container.querySelectorAll('[name="scout_callback_button"], .scout-callback-btn, [class*="callback"], [class*="speak-to"]').forEach(function(btn) {
      btn.style.display = 'none';
    });

    // Intercept clicks on any button that looks like Add to Cart
    container.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-action="add-to-cart"], [name="add"], button[type="submit"], .product-form__submit, .btn-blue, .product-form__add-button');
      if (btn && btn.closest('#cfg-options-embed, #cfg-product-area')) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        // Sync final state before advancing
        syncToBuilder(document.getElementById('cfg-options-embed'), lastLoadedHandle);

        // Advance to free bike step
        if (typeof window.bogoUsGoToFreeBike === 'function') {
          window.bogoUsGoToFreeBike();
        }
        return false;
      }
    }, true); // Use capture phase to catch it before theme JS

    // Also intercept form submissions
    container.addEventListener('submit', function(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      syncToBuilder(document.getElementById('cfg-options-embed'), lastLoadedHandle);

      if (typeof window.bogoUsGoToFreeBike === 'function') {
        window.bogoUsGoToFreeBike();
      }
      return false;
    }, true);
  }

  // ===== INTERCEPT LINKS =====
  function interceptLinks(container) {
    if (!container) return;

    container.addEventListener('click', function(e) {
      var link = e.target.closest('a[href]');
      if (!link) return;

      var href = link.getAttribute('href');
      if (!href) return;

      // Product links → reload the configurator with the new product
      if (href.indexOf('/products/') > -1) {
        e.preventDefault();
        e.stopPropagation();

        var fullUrl = href.indexOf('http') === 0 ? href : window.location.origin + href;
        var handleMatch = href.match(/\/products\/([^?#/]+)/);
        if (handleMatch) {
          lastLoadedHandle = handleMatch[1];
          loadProductPage(fullUrl, handleMatch[1]);

          // Update wheel card selection if matching
          document.querySelectorAll('.bogo-cfg-wheel-card').forEach(function(c) {
            c.classList.remove('selected');
            if (c.dataset.productHandle === handleMatch[1]) {
              c.classList.add('selected');
            }
          });
        }
        return;
      }

      // Variant links → reload
      if (href.indexOf('variant=') > -1) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }

      // Allow anchors and external links, block everything else
      if (href.indexOf('#') !== 0 && href.indexOf('http') !== 0) {
        e.preventDefault();
      }
    });
  }

  // ===== SYNC VARIANT DATA TO BUILDER =====
  function syncToBuilder(container, handle) {
    if (!container) return;

    var data = extractProductData(container, handle);
    if (typeof window.bogoUsUpdateFromConfigurator === 'function') {
      window.bogoUsUpdateFromConfigurator(data);
    }
  }

  function extractProductData(container, handle) {
    var data = {
      variantId: null,
      name: '',
      price: 0,
      handle: handle || '',
      img: '',
      frameSize: '',
      colour: '',
      suspensionPrice: 0,
      suspensionItems: [],
      addons: {}
    };

    // Title
    var titleEl = container.querySelector('.product__title, .product-title, h1, h2');
    if (titleEl) data.name = titleEl.textContent.trim();

    // Price
    var priceEl = container.querySelector('[data-product-price], .product__price .price, .price--current, .price-item--regular, .price-list .price');
    if (priceEl) {
      var priceText = priceEl.textContent.replace(/[^0-9.]/g, '');
      var priceNum = parseFloat(priceText);
      if (priceNum > 0) data.price = priceNum;
    }

    // Variant ID
    var variantInput = container.querySelector('input[name="id"], select[name="id"]');
    if (variantInput) data.variantId = variantInput.value;

    // Image from gallery
    var productArea = document.getElementById('cfg-product-area');
    if (productArea) {
      var img = productArea.querySelector('img[src*="cdn.shopify"]');
      if (img) data.img = img.src;
    }

    // Collect all additional option selections (Fork, Brakes, Battery, etc.)
    // These use class "additional_swatch-input" with data-id and data-price
    var additionalItems = [];
    var properties = {};

    // Checked radio buttons
    container.querySelectorAll('.additional_swatch-input:checked').forEach(function(input) {
      var variantId = input.dataset.id || input.getAttribute('data-id');
      var price = parseInt(input.dataset.price || input.getAttribute('data-price')) || 0;
      var name = input.getAttribute('name') || '';
      var title = input.dataset.title || input.value || '';

      // Skip "No Thanks" / empty / zero-id options
      if (variantId && variantId !== '0' && variantId !== '') {
        additionalItems.push({
          variantId: variantId,
          price: price,
          name: title
        });
      }

      // Collect as cart properties (e.g. properties[Fork] = "Rockshox Bluto")
      if (name && name.indexOf('properties[') > -1) {
        var propKey = name.replace('properties[', '').replace(']', '');
        properties[propKey] = title;
      }
    });

    // Select dropdowns
    container.querySelectorAll('select.additional_swatch-input, select.additional_swatch-input__select').forEach(function(select) {
      var option = select.options[select.selectedIndex];
      if (!option) return;
      var variantId = option.dataset.id || option.getAttribute('data-id');
      var price = parseInt(option.dataset.price || option.getAttribute('data-price')) || 0;
      var name = select.getAttribute('name') || '';
      var title = option.dataset.title || option.value || '';

      if (variantId && variantId !== '0' && variantId !== '') {
        additionalItems.push({
          variantId: variantId,
          price: price,
          name: title
        });
      }

      if (name && name.indexOf('properties[') > -1) {
        var propKey = name.replace('properties[', '').replace(']', '');
        properties[propKey] = title;
      }
    });

    data.additionalItems = additionalItems;
    data.properties = properties;

    return data;
  }

  // ===== OBSERVE VARIANT CHANGES =====
  function observeVariantChanges(container, handle) {
    if (!container) return;

    // Listen for ANY change or click on option selectors
    container.addEventListener('change', function() {
      setTimeout(function() { resolveVariantFromDOM(container, handle); }, 50);
    });

    container.addEventListener('click', function(e) {
      if (e.target.closest('.color-swatch__radio, .color-swatch__item, .color-swatch__label, .block-swatch__radio, .block-swatch__item, .block-swatch__label, .product-form__single-selector')) {
        setTimeout(function() { resolveVariantFromDOM(container, handle); }, 100);
      }
    });
  }

  // ===== RESOLVE VARIANT DIRECTLY FROM THE EMBEDDED SELECT =====
  // The <select name="id"> in the embedded form has all variants as <option> elements.
  // Each <option> has data-variant-media (gallery media ID) and data-variant-pricing (price in cents).
  // We read the currently checked radio buttons, match against the <option> data attributes,
  // then update the <select>, the gallery, and the price — no JSON fetch needed.
  function resolveVariantFromDOM(container, handle) {
    var variantSelect = container.querySelector('select[name="id"]');
    if (!variantSelect) {
      syncToBuilder(container, handle);
      return;
    }

    // Read selected option values from checked radios
    var selectedValues = {};
    container.querySelectorAll('.product-form__single-selector:checked').forEach(function(input) {
      var pos = input.getAttribute('data-option-position');
      if (pos) selectedValues[pos] = input.value;
    });

    // Find matching <option> in the variant select
    var matchedOption = null;
    Array.prototype.forEach.call(variantSelect.options, function(opt) {
      var matches = true;
      Object.keys(selectedValues).forEach(function(pos) {
        // The option stores values in data attributes like data-variant-Frame Size, data-variant-Colour, etc.
        // But we can also match by checking if the option text contains all selected values
        var optText = opt.textContent;
        if (optText.indexOf(selectedValues[pos]) === -1) {
          matches = false;
        }
      });
      if (matches && !matchedOption) {
        matchedOption = opt;
      }
    });

    if (matchedOption) {
      // Update the select to this option
      variantSelect.value = matchedOption.value;

      // Update gallery
      var mediaId = matchedOption.getAttribute('data-variant-media');
      if (mediaId) {
        updateGallerySlide(mediaId);
      }

      // Update price
      var pricing = matchedOption.getAttribute('data-variant-pricing');
      var comparePrice = matchedOption.getAttribute('data-variant-price-compare');
      if (pricing) {
        updatePriceDisplay(container, parseInt(pricing), parseInt(comparePrice) || 0);
      }
    }

    syncToBuilder(container, handle);
  }

  // ===== UPDATE GALLERY SLIDE =====
  function updateGallerySlide(mediaId) {
    var productArea = document.getElementById('cfg-product-area');
    if (!productArea || !mediaId) return;

    // Find all slides in the main gallery
    var mainGallery = productArea.querySelector('#product-gallery--main, .product-gallery--container .swiper');
    if (!mainGallery) return;

    var slides = mainGallery.querySelectorAll('.swiper-slide[data-media-id]');
    var targetIndex = -1;

    slides.forEach(function(slide, i) {
      if (slide.getAttribute('data-media-id') === mediaId) {
        targetIndex = i;
      }
    });

    if (targetIndex === -1) return;

    // Try Swiper API first
    if (mainGallery.swiper) {
      mainGallery.swiper.slideTo(targetIndex);
      return;
    }

    // Fallback: manually show/hide slides
    var wrapper = mainGallery.querySelector('.swiper-wrapper');
    if (wrapper) {
      // Move the wrapper to show the target slide
      var slideWidth = slides[0] ? slides[0].offsetWidth : 0;
      if (slideWidth > 0) {
        wrapper.style.transform = 'translateX(-' + (targetIndex * slideWidth) + 'px)';
        wrapper.style.transition = 'transform 0.3s ease';
      }
    }

    // Update active classes
    slides.forEach(function(s, i) {
      s.classList.toggle('swiper-slide-active', i === targetIndex);
    });

    // Update thumbnails
    var thumbGallery = productArea.querySelector('#product-gallery__thumbnail');
    if (thumbGallery) {
      var thumbSlides = thumbGallery.querySelectorAll('.swiper-slide[data-media-id]');
      thumbSlides.forEach(function(t) {
        t.classList.remove('swiper-slide-thumb-active');
        if (t.getAttribute('data-media-id') === mediaId) {
          t.classList.add('swiper-slide-thumb-active');
        }
      });

      // Scroll thumb into view
      if (thumbGallery.swiper) {
        var thumbIndex = -1;
        thumbSlides.forEach(function(t, i) {
          if (t.getAttribute('data-media-id') === mediaId) thumbIndex = i;
        });
        if (thumbIndex > -1) thumbGallery.swiper.slideTo(thumbIndex);
      }
    }
  }

  // ===== UPDATE PRICE DISPLAY =====
  function updatePriceDisplay(container, priceCents, comparePriceCents) {
    // Update all price displays in the embedded form
    var priceEls = document.querySelectorAll('#cfg-options-embed .total-product-pricing .price-value, #cfg-options-embed .price-list .price .price-value');
    var formattedPrice = '$' + (priceCents / 100).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + ' USD';

    priceEls.forEach(function(el) {
      el.textContent = formattedPrice;
    });

    // Also update price in the product area (if there's one there too)
    var galleryPriceEls = document.querySelectorAll('#cfg-product-area .total-product-pricing .price-value');
    galleryPriceEls.forEach(function(el) {
      el.textContent = formattedPrice;
    });
  }

  // ===== RESET =====
  window.bogoConfigReset = function() {
    lastLoadedHandle = '';

    var productArea = document.getElementById('cfg-product-area');
    var optionsEmbed = document.getElementById('cfg-options-embed');
    var placeholder = document.getElementById('cfg-product-placeholder');

    if (productArea) productArea.innerHTML = '';
    if (placeholder) {
      placeholder.classList.remove('hidden');
      if (productArea) productArea.appendChild(placeholder);
    }
    if (optionsEmbed) optionsEmbed.innerHTML = '<span class="bogo-cfg-placeholder">Select a wheel type above</span>';

    document.querySelectorAll('.bogo-cfg-wheel-card').forEach(function(c) {
      c.classList.remove('selected');
    });

    var optionsSection = document.getElementById('cfg-product-options');
    if (optionsSection) {
      optionsSection.classList.remove('bogo-cfg-unlocked');
      optionsSection.classList.add('bogo-cfg-locked');
    }
  };

  // ===== ADVANCED OPTIONS TAB FIX =====
  // The theme uses a custom tab system for Advanced Options (No/Yes toggle).
  // When HTML is injected via fetch, the theme JS doesn't re-init, so the
  // tabs don't work. This re-implements the tab toggle.
  function initAdvancedOptionsTabs(container) {
    if (!container) return;

    var tabContainer = container.querySelector('#additional-options__tabs');
    if (!tabContainer) return;

    var baseRadio = container.querySelector('#additional-option__base');
    var upgradeRadio = container.querySelector('#additional-option__upgraded-bike');
    var upgradeContent = container.querySelector('div#additional-option__upgraded-bike');

    // The radio and the content div have the same ID — disambiguate
    // The content div is the tab-content, not the input
    if (!upgradeContent || upgradeContent.tagName === 'INPUT') {
      upgradeContent = tabContainer.querySelector('.tab-content[id="additional-option__upgraded-bike"]');
    }
    if (!upgradeContent) {
      upgradeContent = tabContainer.querySelector('.tab.tab-content');
    }

    if (!upgradeContent) return;

    function showAdvanced(show) {
      if (show) {
        upgradeContent.style.display = 'block';
        upgradeContent.classList.add('active');
      } else {
        upgradeContent.style.display = 'none';
        upgradeContent.classList.remove('active');
      }
    }

    // Set initial state based on which radio is checked
    if (upgradeRadio && upgradeRadio.checked) {
      showAdvanced(true);
    } else {
      showAdvanced(false);
    }

    // Listen for radio changes
    if (baseRadio) {
      baseRadio.addEventListener('change', function() {
        if (this.checked) showAdvanced(false);
      });
    }
    if (upgradeRadio) {
      upgradeRadio.addEventListener('change', function() {
        if (this.checked) showAdvanced(true);
      });
    }

    // Also handle clicks on the swatch labels (since theme uses label clicks)
    tabContainer.querySelectorAll('.tab-item').forEach(function(item) {
      item.addEventListener('click', function() {
        var targetId = item.dataset.id;
        var radio = item.querySelector('input[type="radio"]');
        if (radio) radio.checked = true;

        if (targetId && targetId.indexOf('upgraded') > -1) {
          showAdvanced(true);
        } else {
          showAdvanced(false);
        }
      });
    });

    // Also init the upgrade radio cards inside advanced options
    initUpgradeCards(container);
  }

  // ===== UPGRADE CARD RADIO BUTTONS =====
  // The multi-item upgrade cards (Fork, Brakes, etc.) use radio inputs
  // inside .additional-option-item__container. The theme JS handles
  // checked state + price updates, but doesn't run on injected HTML.
  function initUpgradeCards(container) {
    if (!container) return;

    // Handle clicks on upgrade option wrappers (the card-style radio items)
    container.querySelectorAll('.additional-option-item__container .additional-option-item__wrapper').forEach(function(wrapper) {
      wrapper.addEventListener('click', function() {
        var radio = wrapper.querySelector('input[type="radio"], input[type="checkbox"]');
        if (radio && radio.type === 'radio') {
          // Uncheck siblings
          var parent = wrapper.closest('.additional-option-item__container') || wrapper.parentNode;
          parent.querySelectorAll('.additional-option-item__wrapper').forEach(function(w) {
            w.classList.remove('checked');
          });
          radio.checked = true;
          wrapper.classList.add('checked');
        } else if (radio && radio.type === 'checkbox') {
          radio.checked = !radio.checked;
          wrapper.classList.toggle('checked', radio.checked);
        }

        // Sync to builder
        syncToBuilder(container, lastLoadedHandle);
      });
    });

    // Handle select dropdowns in Single-type items
    container.querySelectorAll('.additional_swatch-input__select').forEach(function(select) {
      select.addEventListener('change', function() {
        syncToBuilder(container, lastLoadedHandle);
      });
    });

    // Handle additional swatch radio inputs (warranty, etc.)
    container.querySelectorAll('.additional_swatch-input').forEach(function(input) {
      input.addEventListener('change', function() {
        syncToBuilder(container, lastLoadedHandle);
      });
    });
  }

})();
